import { ClientEvents, ReferralShareLocation } from 'common/events/ClientEvents';
import { getReferralCodeTitle } from 'common/ReferTextUtilities';
import React, { useCallback, useEffect } from 'react';
import { useCurrentUser } from 'src/shared/hooks/useCurrentUserHook';
import { useHistory } from 'src/shared/hooks/useHistory';
import { useTracker } from 'src/shared/hooks/useTracker';
import { ConsumerRoutes } from 'src/shared/Routes';
import { useWSSReferralAdModalStoreSelectors } from 'src/ztore/wss-referral-ad-modal-store';
import { Modal } from 'web-common/src/shared/design-system/components/Modal';
import { WSSReferralAdContent } from './WSSReferralAdContent';

export const WSSReferralAdModal: React.FC = () => {
  const { isWSSReferralAdModalShowing, hideWSSReferralAdModal, analyticsLocation } =
    useWSSReferralAdModalStoreSelectors();
  const [currentUser] = useCurrentUser();
  const history = useHistory();
  const tracker = useTracker();
  const title = currentUser ? getReferralCodeTitle({ referralCode: currentUser.referralCode }) : '';
  const fallbackAnalyticsLocation = ReferralShareLocation.UPCOMING_MEAL_PLAN_ORDERS;
  const finalAnalyticsLocation = analyticsLocation ?? fallbackAnalyticsLocation;

  /**
   * Instead of using Button "to" prop here, we use onClick with history.push
   * because this is rendered outside of React Router, i.e. in the modal component.
   * See web-commmon Button component docs for more details.
   * */
  const handleLearnMoreClick = useCallback(() => {
    hideWSSReferralAdModal();
    tracker.track(ClientEvents.REFERRAL_MEAL_PLAN_MODAL_LEARN_CLICK, {});
    history.push(ConsumerRoutes.CONSUMER_ACCOUNT_SHARE);
  }, [history]);

  const handleClose = useCallback(() => {
    hideWSSReferralAdModal();
    tracker.track(ClientEvents.REFERRAL_MEAL_PLAN_MODAL_CLOSE, {});
  }, [hideWSSReferralAdModal, tracker]);

  useEffect(() => {
    if (isWSSReferralAdModalShowing) {
      tracker.track(ClientEvents.REFERRAL_MEAL_PLAN_MODAL_VIEW, { location: finalAnalyticsLocation });
    }
  }, [isWSSReferralAdModalShowing, tracker, finalAnalyticsLocation]);

  if (!currentUser) {
    return null;
  }

  return (
    <Modal isShowing={isWSSReferralAdModalShowing} onClose={handleClose}>
      <WSSReferralAdContent
        title={title}
        analyticsLocation={finalAnalyticsLocation}
        onClose={handleClose}
        onLearnMore={handleLearnMoreClick}
      />
    </Modal>
  );
};
